

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    data: null,
    investor_types: [],
    deal_flow_columns: [
    // {
    //   Header: "checkbox",
    //   accessor: "checkbox",
    //    fixed: true,   // 👈 add this
    //    align: "start",
    //    left: 0,
    //    hidden:false,
    // },
    {
      Header: "Name",
      accessor: "name",
      minWidth: 300,
      align: "start",
      fixed: true,
      left: 0,
      // left: 50,
      hidden:false,
    },
    // { Header: 'Email', accessor: 'email', minWidth: 150, align: 'start' },
    {
      Header: "Location",
      accessor: "location",
      minWidth: 100,
      align: "center",
      
    },
    { Header: "Founder Name", accessor: "founder_name", minWidth: 100, align: "center",
    },

    { Header: "Source", accessor: "source", minWidth: 100, align: "center",
    },
    { Header: "Stage", accessor: "stage", minWidth: 100, align: "center",
    },
    {
      Header: "Round Size",
      accessor: "totalRoundSize",
      minWidth: 150,
      align: "center",
      
    },
    {
      Header: "Category/Sector",
      accessor: "category_sub_sector",
      minWidth: 100,
      align: "center",
      
    },
    {
      Header: "Status",
      accessor: "pipeline_status_value",
      minWidth: 100,
      align: "center",
      
    },
    // { Header: 'Date', accessor: 'in_progress_date', minWidth: 100, align: 'center' },
    {
      Header: "Date",
      accessor: "pipelineUpdatedDate",
      minWidth: 100,
      align: "center",
      
    },
    // { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center' },
    {
      Header: "Interested Amount",
      accessor: "_interested_amount",
      minWidth: 150,
      align: "center",
      
    },
    {
      Header: "Allocated Amount",
      accessor: "_allocated_amount",
      minWidth: 150,
      align: "center",
      
    },
    {
      Header: "Pitch Deck",
      accessor: "pitch_deck",
      minWidth: 100,
      align: "center",
      
    },
    { Header: "Links", accessor: "links", minWidth: 100, align: "center",
       },
    // { Header: 'Funding round', accessor: 'funding_round', minWidth: 100, align: 'center' },
    { Header: "Actions", accessor: "actions", minWidth: 100, align: "right",hidden:false, },
  ]
}

const investorDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_INVESTOR_DETAILS:
            return {
                ...state,
                data: action.data
            }
        case actionTypes.SET_INVESTOR_TYPES:
            return {
                ...state,
                investor_types: action.investor_types
            }
        default:
            return state; 
    }
}

export default investorDetailsReducer
